{
  "version": 1,
  "asset_id": "fc3c96f7-24d6-409f-9539-565653287fe9",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/fc3c96f7-24d6-409f-9539-565653287fe9/appliances-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/fc3c96f7-24d6-409f-9539-565653287fe9/appliances-thumb.webp",
  "original_filename": "appliances-thumb.webp",
  "size": 4836,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:29:56Z"
}
